export class QuestionResponse {
  id: number;
  Client: string;
  Project: string;
  QuestionId = 0;
  Value = 5;
  StatusId = 6;
  Comment = '';
  EntryBy = 'Frontend';
  EntryDate: Date = new Date();
  isSuperUserEntry: boolean;
}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/models/response.model.ts